// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"386":"06d051db","425":"e2ebaf7c"}[chunkId] + ".js";
};